function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m404 148c0-81.605469-66.394531-148-148-148s-148 66.394531-148 148c0 50.546875 25.480469 95.25 64.261719 121.964844-36.210938 12.492187-69.398438 33.132812-97.28125 61.015625-48.351563 48.351562-74.980469 112.640625-74.980469 181.019531h40c0-119.101562 96.898438-216 216-216 81.605469 0 148-66.394531 148-148zm-148 108c-59.550781 0-108-48.449219-108-108s48.449219-108 108-108 108 48.449219 108 108-48.449219 108-108 108zm66 135.980469h190v40h-190zm190-79.980469v40h-190v-40zm-190 160h190v40h-190zm0 0"
});

var SvgTodo = function SvgTodo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTodo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/todo.c268e1b5.svg";
export { ForwardRef as ReactComponent };